import { useQueryClient } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import Toast from '@/components/ui/Toast/toast';
import { createParsedEventHandler } from '@/hooks/socket/socket.helpers';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import { AppRoutes } from '@/i18n/constants';
import { useRouter } from '@/i18n/routing';
import { useAppSelector } from '@/redux/hooks';
import { QueriesKeys } from '../queriesKeys';
import {
  FreeSpinPackAssignedContextSchema,
  FreeSpinPackUnassignedContextSchema,
} from './userFreeSpins.schema';

export const FREE_SPIN_SOCKET_EVENTS = {
  freeSpinPackAssigned: 'free-spin-pack.assigned',
  freeSpinPackUnassigned: 'free-spin-pack.unassigned',
} as const;

export function useUserFreeSpinsSocket() {
  const userSession = useAppSelector(state => state.user.userSession);
  const isSessionActive = Boolean(userSession);
  const queryClient = useQueryClient();
  const t = useTranslations('gamification.free-spins.assigned-toast');
  const router = useRouter();

  const handleFreeSpinPackAssigned = createParsedEventHandler(
    FreeSpinPackAssignedContextSchema,
    (data) => {
      void queryClient.invalidateQueries({ queryKey: [QueriesKeys.meUserFreeSpins] });
      // TODO: will be changed after design is finalized
      Toast({
        id: `free-spin-pack-assigned-${data.userFreeSpinId}`,
        type: 'success',
        title: t('title'),
        description: t('description'),
        acceptButtonText: t('view'),
        rejectButtonText: t('later'),
        onAccept: () => router.push(AppRoutes.gamificationFreeSpins),
      });
    },
  );

  const handleFreeSpinPackUnassigned = createParsedEventHandler(
    FreeSpinPackUnassignedContextSchema,
    () => {
      void queryClient.invalidateQueries({ queryKey: [QueriesKeys.meUserFreeSpins] });
    },
  );

  useSocketEvent(
    FREE_SPIN_SOCKET_EVENTS.freeSpinPackAssigned,
    handleFreeSpinPackAssigned,
    isSessionActive,
  );

  useSocketEvent(
    FREE_SPIN_SOCKET_EVENTS.freeSpinPackUnassigned,
    handleFreeSpinPackUnassigned,
    isSessionActive,
  );
}
